import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import "../Assets/css/references.css";
import { BASE_URL } from "../env";
import VideoPlayer from "react-video-js-player";
const References = (props) => {
	const [videos, setVideos] = useState([]);
	const [Data, setdata] = useState("");
	const [toolKits, setToolKits] = useState([]);
	useEffect(() => {
		console.log(props);
		setVideos(props.videos);
		fetch(BASE_URL + "/smallCourses/getAllcourses", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setdata(data);
				console.log("Data from reference.js", data);
				data.data.map((item) => {
					setToolKits(item.toolkits);
				});
			});
		console.log(videos);
	}, []);
	useEffect(() => {
		console.log(videos);
	}, [videos]);

	return (
		<div>
			<div className="container">
				<div className="heading mb-4 bg-primary text-light py-3 px-2 rounded">
					<h5 style={{ marginBottom: "0px" }}>
						{" "}
						Data structure and Algorithms{" "}
						<i class="fas fa-film"></i>{" "}
					</h5>
				</div>
				<h5>Stacks & Queue</h5>
				<div
					className="row  px-2  example "
					style={{ overflowX: "scroll" }}
				>
					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/STACKS+%26+QUEUES/stacks+and+queue(Topic-1).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 1</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/STACKS+%26+QUEUES/stacks+and+queue(Topic-2).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 2</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/STACKS+%26+QUEUES/stacks+and+queue(Topic+-+3).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 3</h6>
						</div>
					</div>
				</div>
				{/* Stacks and queues end here */}

				{/* strings and arrays start here */}
				<h5>Arrays and Strings</h5>
				<div
					className="row  px-2  example "
					style={{ overflowX: "scroll" }}
				>
					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Arrays+%26+Strings/Arrays+and+Strings(Part+-1).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 1</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Arrays+%26+Strings/Arrays+and+Strings(Part+-2).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 2</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Arrays+%26+Strings/Arrays+and+Strings(Part+-3).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 3</h6>
						</div>
					</div>
				</div>
				<h5>Searching and Sorting</h5>
				<div
					className="row  px-2  example "
					style={{ overflowX: "scroll" }}
				>
					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Searching+%26+Sorting/Searching+%26+Sorting+(Topic+1).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 1</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Searching+%26+Sorting/Searching+%26+Sorting+(Topic+2).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 2</h6>
						</div>
					</div>

					<div
						class="card mx-4 my-4 p-0"
						style={{ width: "17rem", height: "14rem" }}
						key={1}
					>
						<iframe
							src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Searching+%26+Sorting/Searching+%26+Sorting+(Topic+3).mp4"
							className="video-container video-container-overlay video"
							controls
							autoPlay={false}
							allowFullScreen
							sandbox
						></iframe>

						<div class="card-body">
							<h6 class="card-title">Topic 3</h6>
						</div>
					</div>
				</div>

				<div className="heading mb-4 bg-primary text-light py-3 px-2 rounded">
					<h5 style={{ marginBottom: "0px" }}>
						{" "}
						Interview preparation
					</h5>
				</div>
				<div
					className="row px-2 example "
					style={{ overflowX: "scroll" }}
				>
					{/* {toolKits.map((item) => {
            return (
              <div
                class="card mx-4 my-4 p-0"
                style={{ width: "17rem" }}
                key={item._id}
              >
                {/* <video src={val.link}></video> */}
					{/* <div class="card-body">
                  <h6 class="card-title">{item.name}</h6>
                  <p class="card-text borders">
                    <span className="text-muted">
                      Date added: {item.date.substring(0, 10)}
                    </span>
                  </p>
                  <div className="d-flex justify-content-center">
                    <a href={item.link} class="btn btn-primary borders">
                      Link
                    </a>
                  </div>
                </div>
              </div> */}
					<h5>Mock interviews</h5>
					<div
						className="row  px-2  example "
						style={{ overflowX: "scroll" }}
					>
						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Free+Mock+Interview/Mock+Interview+1"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">Interview 1</h6>
							</div>
						</div>

						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Free+Mock+Interview/Mock+Interview+2"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">Interview 2</h6>
							</div>
						</div>

						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Free+Mock+Interview/Mock+Interview+3+"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">Interview 3</h6>
							</div>
						</div>
					</div>
					<div className="heading mb-4 bg-primary text-light py-3 px-2 rounded">
						<h5 style={{ marginBottom: "0px" }}>
							{" "}
							Aptitude preparation
						</h5>
					</div>

					<h5>Mock interviews</h5>
					<div
						className="row  px-2  example "
						style={{ overflowX: "scroll" }}
					>
						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Aptitude+preparation/Clocks.mp4"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">Topic-1 Clocks</h6>
							</div>
						</div>

						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Aptitude+preparation/Number+System.mp4"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">
									Topic-2 Number System
								</h6>
							</div>
						</div>

						<div
							class="card mx-4 my-4 p-0"
							style={{ width: "17rem", height: "14rem" }}
							key={1}
						>
							<iframe
								src="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Aptitude+preparation/Time+%26+Work.mp4"
								className="video-container video-container-overlay video"
								controls
								autoPlay={false}
								allowFullScreen
								sandbox
							></iframe>

							<div class="card-body">
								<h6 class="card-title">Topic-3 Time & Work </h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default References;
